import React from "react";
import Link from "gatsby-link";
import get from "lodash.get";
import map from "lodash.map";
import forEach from "lodash.foreach";
import GatsbyConfig from "../../../gatsby-config.js";
import { isHawaiiTime, isIOSDevice } from "../../utils/app-helpers";
import SiteFooter from "../../components/partials/site-footer";
import HelmetWrapper from "../../components/partials/helmet-wrapper";
import SiteHeader from "../../components/partials/site-header";
import AngleBanner from "../../components/partials/angle-banner";
import Countdown from "../../components/partials/countdown";
import NewsletterCallout from "../../components/partials/newsletter-callout";

const { siteMetadata: config } = GatsbyConfig;

export default class SplashPage extends React.Component {
  render() {
    const title = "Christian Travel for Couples | Love Song Couples Getaway";
    const description =
      "Check out this unique Christian Travel experience for couples at The " +
      "Ritz-Carlton, Cancun and The Ritz-Carlton, Kapalua in Maui!";
    const availableTrips = [];
    const isHST = isHawaiiTime();
    const isIOS = isIOSDevice();

    forEach(config.trips, (tripData) => {
      if (!tripData.available || (tripData.useHawaiiSplashMasking && isHST)) {
        return;
      }
      availableTrips.push(tripData);
    });

    return (
      <div className="page-at-root page-home">
        <HelmetWrapper metaTitle={title} metaDescription={description} />
        <SiteHeader />
        <main
          className="splash-grid"
          style={{
            gridTemplateColumns: `repeat(${availableTrips.length}, 1fr)`,
          }}
        >
          {!availableTrips.length && (
            <div
              className="image"
              style={{
                backgroundImage: `url(/images/book-callout-kauai2021-bg.jpg)`,
              }}
            >
              <NewsletterCallout requireFirstName requireLastName />
              <p className="social">
                <a
                  target={isIOS ? undefined : "_blank"}
                  href={config.urls[isIOS ? "facebookApp" : "facebook"]}
                  aria-title="Facebook"
                >
                  <i className="fa fa-facebook-square" />
                </a>
                <a
                  target={isIOS ? undefined : "_blank"}
                  href={config.urls[isIOS ? "instagramApp" : "instagram"]}
                  aria-title="Instagram"
                >
                  <i className="fa fa-instagram" />
                </a>
              </p>
            </div>
          )}
          {map(availableTrips, (tripData) => {
            const { mainPageModal } = tripData;
            const modalButton = get(mainPageModal, "button");
            const useModal = !!get(mainPageModal, "enabled");
            const countdown = get(mainPageModal, "countdown");

            return (
              <div
                className={`image ${tripData.slug}${useModal ? " darken" : ""}`}
                style={{
                  backgroundImage: `url(/images/home-splash-${tripData.slug}.jpg)`,
                }}
              >
                {countdown && <Countdown date={new Date(countdown)} />}
                {tripData.soldOut ? (
                  <AngleBanner>Sold Out</AngleBanner>
                ) : tripData.customSplashBanner ? (
                  <AngleBanner color={tripData.customSplashBannerColor}>
                    {tripData.customSplashBanner}
                  </AngleBanner>
                ) : (
                  ""
                )}
                {useModal && mainPageModal.title && (
                  <h2 className="splash-modal-title">{mainPageModal.title}</h2>
                )}
                {useModal && mainPageModal.message && (
                  <div
                    className="splash-modal-message"
                    dangerouslySetInnerHTML={{ __html: mainPageModal.message }}
                  />
                )}
                {useModal && modalButton && modalButton.path && (
                  <a
                    className="btn"
                    href={modalButton.path}
                    {...(modalButton.path.match(/^http/i)
                      ? { target: "_blank", rel: "noopener noreferrer" }
                      : null)}
                  >
                    {modalButton.text}
                  </a>
                )}
                {useModal && modalButton && !modalButton.path && (
                  <span className="btn nolink">{modalButton.text}</span>
                )}
                {useModal && !modalButton && (
                  <Link className="btn" to={`/${tripData.slug}/`}>
                    {tripData.name} {tripData.year}
                  </Link>
                )}
              </div>
            );
          })}
        </main>
        <SiteFooter />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/splash.js